// ─────────────────────────────────────────────────────────────────────────────
// gtm.js – Google Tag Manager dynamický loader + Consent Mode v2 helper
//
// GDPR compliance:
//  - GTM sa načíta AŽ po udelení aspoň jedného marketingového/analytického súhlasu.
//  - Consent Mode v2 defaulty sú nastavené v public/index.html PRED týmto skriptom.
//  - Pri zmene súhlasu zavoláme gtag('consent', 'update', {...}) → GTM notifikuje
//    všetky tagy (GA4, Meta Pixel, Google Ads) aby zodpovedajúco reagovali.
//
// Nastavenie: REACT_APP_GTM_ID v .env (napr. GTM-XXXXXXX)
// ─────────────────────────────────────────────────────────────────────────────

const GTM_ID = process.env.REACT_APP_GTM_ID;

let initialized = false;

/**
 * Dynamicky načíta GTM skript a noscript iframe.
 * Volajte VÝHRADNE po získaní aspoň jedného súhlasu (analytics alebo marketing).
 */
export function initGTM() {
  if (initialized || !GTM_ID) return;

  window.dataLayer = window.dataLayer || [];

  // GTM hlavný skript
  const script = document.createElement("script");
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`;
  document.head.appendChild(script);

  // GTM noscript fallback
  const noscriptContainer = document.getElementById("gtm-noscript");
  if (noscriptContainer) {
    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    noscriptContainer.appendChild(noscript);
  }

  initialized = true;
}

/**
 * Aktualizuje GTM Consent Mode v2 signály podľa aktuálneho stavu súhlasu.
 * Volajte vždy, keď sa zmení súhlas (accept, reject, custom save).
 *
 * @param {{ analytics: boolean, marketing: boolean, preferences: boolean }} consent
 */
export function updateGTMConsent({ analytics, marketing, preferences }) {
  if (typeof window.gtag !== "function") return;

  window.gtag("consent", "update", {
    analytics_storage:       analytics  ? "granted" : "denied",
    ad_storage:              marketing  ? "granted" : "denied",
    ad_user_data:            marketing  ? "granted" : "denied",
    ad_personalization:      marketing  ? "granted" : "denied",
    personalization_storage: preferences ? "granted" : "denied",
    functionality_storage:   preferences ? "granted" : "denied",
  });
}

/**
 * Pošle vlastný event do dataLayer (napr. pre Meta Pixel alebo Google Ads tag v GTM).
 *
 * Príklady eventov:
 *   pushGTMEvent('purchase', { value: 29.99, currency: 'EUR', transaction_id: 'pi_xxx' })
 *   pushGTMEvent('generate_lead', { form_name: 'registration' })
 *   pushGTMEvent('complete_registration')
 *
 * @param {string} eventName
 * @param {Record<string, any>} [data]
 */
export function pushGTMEvent(eventName, data = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...data });
}
